module.exports = __webpack_public_path__ + "static/media/RCP Terms & Conditions New.2ac4e4ab.pdf";